import * as three from 'three';
import { Vec3Like } from './vec-like';

export class Matrix3 extends three.Matrix3{
}

export class Matrix4 extends three.Matrix4{
}

export interface Matrix4{
	compose(translation:Vec3Like, rotation:three.Quaternion, scale:Vec3Like):this;
	identity():this;
	scale(v:Vec3Like):this;
	setPosition(v:Vec3Like|number, y?:number, z?:number):this;
}
